import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart3 } from 'lucide-react';
import { demandBarWidth, demandTone, formatTimes } from '../../utils/topSubscribed';

const MEDALS = ['bg-amber-100 text-amber-700', 'bg-slate-200 text-slate-600', 'bg-orange-100 text-orange-700'];

// rows: utils/topSubscribed.js mapTopSubscribedRows (already ranked)
export const TopDemandLeaderboard = ({ rows, loading, count = 8 }) => {
  const top = rows.slice(0, count);
  const max = top[0]?.times || 0;

  return (
    <section aria-labelledby="demand-leaderboard-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <h2 id="demand-leaderboard-heading" className="flex items-center gap-2 text-sm sm:text-base font-extrabold text-slate-900">
            <BarChart3 className="w-4 h-4 text-[#008080]" aria-hidden="true" />
            Demand Leaderboard
          </h2>
          <p className="mt-0.5 text-[11px] text-slate-500">Times subscribed across the public book, anchor portion excluded</p>
        </div>
        <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Log scale</span>
      </div>

      {loading ? (
        <ul className="mt-4 space-y-3" aria-hidden="true">
          {Array.from({ length: 5 }).map((_, idx) => (
            <li key={idx} className="h-9 rounded-lg bg-slate-100 animate-pulse" />
          ))}
        </ul>
      ) : top.length ? (
        <ol className="mt-4 space-y-3">
          {top.map((row, index) => {
            const tone = demandTone(row.times);
            return (
              <li key={row.id}>
                <div className="flex items-center justify-between gap-3 text-xs">
                  <span className="flex items-center gap-2 min-w-0">
                    <span
                      className={`w-5 h-5 rounded-md text-[10px] font-extrabold flex items-center justify-center flex-shrink-0 ${
                        MEDALS[index] || 'bg-slate-100 text-slate-500'
                      }`}
                    >
                      {row.rank}
                    </span>
                    {row.link ? (
                      <Link to={row.link} className="font-bold text-slate-800 hover:text-[#008080] truncate">
                        {row.name}
                      </Link>
                    ) : (
                      <span className="font-bold text-slate-800 truncate">{row.name}</span>
                    )}
                    <span className="hidden sm:inline text-[10px] font-semibold text-slate-400 flex-shrink-0">{row.board}</span>
                  </span>
                  <span className="font-extrabold text-slate-900 tabular-nums whitespace-nowrap">{formatTimes(row.times)}</span>
                </div>
                <div className="mt-1 h-2 rounded-full bg-slate-100 overflow-hidden" aria-hidden="true">
                  <div className={`h-full rounded-full ${tone.bar}`} style={{ width: `${demandBarWidth(row.times, max)}%` }} />
                </div>
              </li>
            );
          })}
        </ol>
      ) : (
        <p className="mt-4 rounded-xl border border-dashed border-slate-200 bg-slate-50 px-3 py-8 text-center text-xs text-slate-500">
          No subscription figures yet. Issues appear here once bidding opens.
        </p>
      )}
    </section>
  );
};

export default TopDemandLeaderboard;
